import { VehicleDisclaimer } from '@/components/index';
import { useAppConstantsContext } from '@/context/AppConstants';
import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { AutomobileAccidents } from '@/reports/types/vehicles';
import { Stack, Text } from '@/theme/index';
import { pluralizeString } from '@/utils/pluralizeString';
import { VehicleAccidentCard } from './VehicleAccidentCard';

interface VehicleAccidents {
  vehicleAccidentsList: AutomobileAccidents;
}

export function VehicleAccidents({ vehicleAccidentsList }: VehicleAccidents) {
  const {
    images: { accidentsCoverageMapImage },
  } = useAppConstantsContext();

  function HowItWorksCTAContent() {
    return (
      <Stack direction="column" spacing={2}>
        <img src={accidentsCoverageMapImage} alt="map" />
        <VehicleDisclaimer fontSize="16px" />
      </Stack>
    );
  }

  const title = `${vehicleAccidentsList?.length || 0} ${pluralizeString(
    'Accident',
    vehicleAccidentsList?.length
  )} Reported`;

  return (
    <DataCard testId="vehicle-accidents-report-section">
      <Text data-testid="report-section-title-text" variant="h2">
        {title}
      </Text>
      {vehicleAccidentsList &&
        vehicleAccidentsList.map((accident, index) => (
          <VehicleAccidentCard accident={accident} key={index} />
        ))}
      {vehicleAccidentsList?.length > 0 && (
        <VehicleDisclaimer openingAlert fontSize="16px" />
      )}
      {vehicleAccidentsList?.length === 0 && (
        <>
          <EmptyVehicleSectionDisclaimer title="accident" />
          <HowItWorksCTA content={HowItWorksCTAContent()} />
        </>
      )}
    </DataCard>
  );
}
